import { useMemo } from 'react';
function useFromQuery() {
  var search = new URLSearchParams(window.location.search);
  var from = search.get('from');
  var encodeFrom = from ? "from=" + encodeURIComponent(from) : '';
  return useMemo(function () {
    return encodeFrom;
  }, [encodeFrom]);
}
export default useFromQuery;